import { ReactNode } from 'react';
import { Box, Center, Flex, Loader } from '@mantine/core';
import { LogoWithIcon, HEADER_HEIGHT } from 'src/UI/app-container/header/Header';
import { useIsMobile } from 'src/common/hooks/useIsMobile';

interface AuthPageLayoutProps {
  isLoading?: boolean;
  withHeader?: boolean;
  children?: ReactNode;
}

export const AuthPageLayout = ({
  isLoading = false,
  withHeader = false,
  children,
}: AuthPageLayoutProps) => {
  const { isMobile } = useIsMobile();
  const centerHeight = withHeader ? `calc(100vh - ${HEADER_HEIGHT}px)` : '100%';

  const content = isLoading ? <Loader color="gray.0" size="lg" /> : children;

  return isMobile ? (
    <Box bg="gray.0" h="100vh">
      {content}
    </Box>
  ) : (
    <Box bg="gray.10" h="100vh">
      {withHeader && (
        <Flex h={HEADER_HEIGHT} px="xxl" align="center">
          <LogoWithIcon textColor="gray.0" />
        </Flex>
      )}

      <Center h={centerHeight}>{content}</Center>
    </Box>
  );
};
